import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

const SEO = ({
  description = "",
  lang = "en",
  meta = [],
  title,
  titleWithoutPostfix = false,
  image,
  type = "website",
}) => {
  //
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            siteUrl
          }
        }
      }
    `
  )

  const metaTitle = titleWithoutPostfix
    ? title
    : `${title} | ${site.siteMetadata.title}`
  const metaDescription = description || site.siteMetadata.description
  const metaImage = image
    ? image[0] === "/"
      ? `${site.siteMetadata.siteUrl}${image}`
      : image
    : `${site.siteMetadata.siteUrl}/pxp.png`

  return (
    <>
      <html lang={lang} />

      {/* Primary Meta Tags */}
      <title>{metaTitle}</title>
      <meta id="title" name="title" content={metaTitle} />
      <meta id="description" name="description" content={metaDescription} />

      {/* Open Graph / Facebook */}
      <meta id="og:type" property="og:type" content={type || "website"} />
      <meta id="og:url" property="og:url" content={site.siteMetadata.siteUrl} />
      <meta id="og:title" property="og:title" content={title} />
      <meta
        id="og:description"
        property="og:description"
        content={metaDescription}
      />
      <meta id="og:image" property="og:image" content={metaImage} />

      {/* Twitter */}
      <meta
        id="twitter:card"
        property="twitter:card"
        content="summary_large_image"
      />
      <meta
        id="twitter:url"
        property="twitter:url"
        content={site.siteMetadata.siteUrl}
      />
      <meta
        id="twitter:creator"
        property="twitter:creator"
        content="Press'nXPress"
      />
      <meta id="twitter:title" property="twitter:title" content={title} />
      <meta
        id="twitter:description"
        property="twitter:description"
        content={metaDescription}
      />
      <meta id="twitter:image" property="twitter:image" content={metaImage} />

      {/* keywords */}
      {meta?.map(({ id, name, property, content }, index) => (
        <meta
          key={index}
          id={id}
          name={name}
          property={property}
          content={content}
        />
      ))}
    </>
  )
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  titleWithoutPostfix: PropTypes.bool,
  image: PropTypes.string,
  type: PropTypes.oneOf(["website", "article"]),
}

export default SEO
